import { lighten } from '@material-ui/core/styles/colorManipulator';
import { emphasize } from '@material-ui/core/styles/colorManipulator';
import { fade } from '@material-ui/core/styles/colorManipulator';

export const styles = theme => ({
  tableCellInCollapes: {
    borderBottom: 'none'
  },
  root: {
    width: '100%',
    marginTop: theme.spacing(3),
  },
  table: {
    minWidth: 1020,
  },
  tableWrapper: {
      overflowX: 'auto',
      position: 'relative'
  },
  editComponent: {
    display: 'none'
  },
  editButton: {
    cursor: 'pointer'
  },
  saveButton: {
    cursor: 'pointer',
    fontSize: '0.8125rem',
    margin: '0pc 6px',
  },
  iconEdit : {
    width: '16px',
    height: '16px',
    cursor: 'pointer',
  },
  imgText:{    
    cursor: 'pointer',
    fontSize: '0.6125rem',
    color: '#3f51b5',
  },
  textField: {
    width: '100%',
  },
  customRoot: {
    width: '100%',
  },
  infoBranch: {
    padding: '10px',
  },
  detailBranch: {
    marginLeft: '8px',
  },
  selectedMenu: {
    '&:focus': {
      backgroundColor: 'transparent',
    }
  },
  // new modify
  tableRowHeight:{
    height:0
  },
  containerButton:{ 
    display: 'flex'
  },
  buttonOnRow: {
    width: '-webkit-fill-available',
    margin: '0.2rem'
  },
});

export const tableHeadStyles = theme => ({
  head : {
    
    fontSize : '14px',
    fontWeight : '450',
    paddingRight : 26,
  },
  headFirst : {
    padding: '0px 12px',
    
    fontSize : '14px',
    fontWeight : '460',
  }
});

export const toolbarStyles = theme => ({
  root: {
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === 'light'
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  spacer: {
    flex: '1 1 100%',
  },
  actions: {
    color: theme.palette.text.secondary,
  },
  title: {
    flex: '0 0 auto',
  },
  
});
